const semanticClassNames = {
    icon: 'radio__icon',
};
export default semanticClassNames;
//# sourceMappingURL=Radio.semanticClassNames.js.map